const isObject = (item) => {
  if (typeof item !== 'object' || item === null) {
    return false // Not an object, or is null
  }

  // Check the prototype chain
  let proto = Object.getPrototypeOf(item)

  // An object with a null prototype (like from Object.create(null)) is a plain object
  if (proto === null) {
    return true
  }

  // The prototype should be Object.prototype for a plain object
  return proto === Object.prototype
}

const mergeDeep = (source, target, sourceOnly = false) => {
  const newSource = { ...source }

  Object.keys(target).forEach((key) => {
    if (isObject(source[key]) && isObject(target[key])) {
      // if both vals are objs, recursively merge
      newSource[key] = mergeDeep(newSource[key], target[key], sourceOnly)
    } else if (Array.isArray(source[key]) && Array.isArray(target[key])) {
      // if both vals are arrs, concat and remove dupes
      const newArr = source[key].concat(target[key])
      newSource[key] = [...new Set(newArr)]
    } else if (sourceOnly && !(key in source)) {
      // if key is not defined by source, ignore it
      return
    } else {
      // overwite by default
      newSource[key] = target[key]
    }
  })

  return newSource
}

export default mergeDeep
